import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Registration API - Base definition
 *
 * This is the base API slice for the Registration service.
 * Note: This service uses the Encounters API base URL.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see registrationEndpoints.ts - Registration CRUD operations
 * @see dimensionEndpoints.ts - Dimension lookups (gender, race, etc.)
 */
export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.encounters), // Uses encounters API
  tagTypes: ['Registration', 'Registrations'],
  endpoints: () => ({}),
});

